import React, { useState } from 'react';
import './DoctorsPage.css'; // Create a new CSS file for this component
import { mockDisciplines, mockDoctors } from './mockData'; // Import the mock data
import { Link } from "react-router-dom";

const DoctorsPage = () => {
  const [selectedDiscipline, setSelectedDiscipline] = useState('');
  const [filteredDoctors, setFilteredDoctors] = useState([]);
  const [expandedDoctorId, setExpandedDoctorId] = useState(null);

  const toggleReadMore = (id) => {
    setExpandedDoctorId(expandedDoctorId === id ? null : id); // Toggle the current doctor's bio
  };


  const handleDisciplineChange = (event) => {
    const discipline = event.target.value;
    setSelectedDiscipline(discipline);
    setFilteredDoctors(mockDoctors[discipline] || []);
  };

  return (
    <div className="doctors-page-container">
      <h1 className="doctors-title">Our Doctors</h1>
      <p className="description">Choose a discipline to view our doctors.</p>

      {/* Discipline Filter */}
      <div className="discipline-select-container">
        <label>Select Discipline:</label>
        <select value={selectedDiscipline} onChange={handleDisciplineChange}>
          <option value="">--Select Discipline--</option>
          {mockDisciplines.map((discipline, index) => (
            <option key={index} value={discipline}>
              {discipline}
            </option>
          ))}
        </select>
      </div>

      {/* Doctors List */}
      <div className="doctors-grid">
        {filteredDoctors.map((doctor) => (
          <div key={doctor.id} className="doctor-card">
            <div className="doctor-image-container">
              <img src={doctor.image} alt={doctor.name} className="doctor-image" />
            </div>
            <div className="doctor-info">
              <h3 className="doctors-name">{doctor.name}</h3>
              <p className="doctor-specialties"><strong>Specialties:</strong> {doctor.specialties.join(', ')}</p>
              <p className="doctor-experience"><strong>Experience:</strong> {doctor.experience} years</p>
              <p className="doctor-achievements"><strong>Achievements:</strong> {doctor.achievements}</p>
              <div className={`doctor-bio ${expandedDoctorId === doctor.id ? 'expanded' : ''}`}>
                <p>{doctor.bio}</p>
              </div>
              <div className="doctor-actions">
              <button
                className="read-more-btn"
                onClick={() => toggleReadMore(doctor.id)}
              >
                {expandedDoctorId === doctor.id ? 'Read Less' : 'Read More'}
              </button>
              {/* "Want to see more?" link to the detailed doctor page */}
              <Link to={`/doctor/${doctor.id}`} className="see-more-link">
                Want to see more?
              </Link>
            </div>
            </div>
          </div>
        ))}
      </div>

    </div>
  );
};

export default DoctorsPage;
